import React from 'react'
import FavPages from './FavPages'
import Search from './Search'
import LanguageSwitcher from './LanguageSwitcher'
import Actions from './Actions'
import UserMenu from './UserMenu'
import style from './style.module.scss'

const TopBar = () => (
  <div className={style.topbar}>
    <div className="me-4">
      <FavPages />
    </div>
    <div className="me-auto">
      <Search />
    </div>
    <div className="me-4 d-none d-sm-block">
      <LanguageSwitcher />
    </div>
    <div className="me-4 d-none d-sm-block">
      <Actions />
    </div>
    <div className="">
      <UserMenu />
    </div>
  </div>
)

export default TopBar
